export { SimpleInput } from './SimpleInput'


// WEBPACK FOOTER //
// ./src/components/Autocomplete/components/SimpleInput/index.js